module.exports = __webpack_public_path__ + "media/images/icons/whatsapp-474ee56b28c1808f9078053a20cd3712.svg";